import { useDispatch, useSelector } from 'react-redux';
import {
  getUserSettingsSelector,
  setUserSettings,
  setUserSettingsIsLoading,
} from '../redux/userSettings/userSettingsSlice';
import { saveUserTheme } from '../services/userSettingsService';
import { loadUserSettingsThunk } from '../redux/userSettings/userSettingsThunk';

export const useThemeSwitch = () => {
  const currentUserSettings = useSelector(getUserSettingsSelector) as {
    loading: boolean;
    settings: { darkMode: boolean };
  };
  const dispatch = useDispatch();

  return async (isDarkMode: boolean, allowSwitchOnFail = true) => {
    let isSucceeded = false;
    if (
      !currentUserSettings.loading &&
      !!currentUserSettings.settings.darkMode !== isDarkMode
    ) {
      dispatch(setUserSettingsIsLoading(true));
      try {
        dispatch(
          setUserSettings({
            darkMode: isDarkMode,
          })
        );
        await saveUserTheme(isDarkMode);
        isSucceeded = true;
      } catch (e) {
        dispatch(setUserSettingsIsLoading(false));
      } finally {
        if (!allowSwitchOnFail || isSucceeded) {
          dispatch(loadUserSettingsThunk());
        }
      }
    }
    return isSucceeded;
  };
};
